import Icon from '../components/Icon.vue'

Icon.register({
  book: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 360c0 7.5-3.5 14.3-8.9 18.6-4.2 15.4-4.2 59.3 0 74.7 5.4 4.4 8.9 11.2 8.9 18.7v16c0 13.3-10.7 24-24 24h-328c-53 0-96-43-96-96v-320c0-53 43-96 96-96h328c13.3 0 24 10.7 24 24v336zM128 134v20c0 3.3 2.7 6 6 6h212c3.3 0 6-2.7 6-6v-20c0-3.3-2.7-6-6-6h-212c-3.3 0-6 2.7-6 6zM128 198v20c0 3.3 2.7 6 6 6h212c3.3 0 6-2.7 6-6v-20c0-3.3-2.7-6-6-6h-212c-3.3 0-6 2.7-6 6zM381.4 448c-1.9-17.1-1.9-46.9 0-64h-285.4c-17.6 0-32 14.4-32 32 0 17.7 14.3 32 32 32h285.4z'
      }
    ]
  }
})
